import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { binCountSessionIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const activeSessionSchema = z.object({
  binCountSessionId: binCountSessionIdFormat.schema,
  totalBins: z.number(),
  completedBins: z.number(),
  sessionType: z.enum(["binCount", "skuCount"]),
  productId: productIdFormat.schema.optional(),
  productTitle: z.string().optional(),
  productSku: z.string().optional(),
});

export const getActiveBinCountSession = {
  name: "getActiveBinCountSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.array(activeSessionSchema),
};
